import axios from 'axios';
import { LargeCategory } from '../../redux/reducers/SearchCategoryReducer';
import { BAD_REQUEST, CommonResult, INTERNAL_SERVER_ERROR, OK, CommonRequest, MST_DATA_GET_FAILED } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

const endpoint = process.env.REACT_APP_API_URL;
const url = `${endpoint}/category`;

export type CategoryGetApiRequest = CommonRequest;

export interface CategoryGetApiResponse {
  result: CommonResult;
  largeCategory?: LargeCategory[];
}

/**
 * 詳細設定条件取得API
 * @param request リクエスト
 */
export async function categoryGetApi(request: CategoryGetApiRequest): Promise<CategoryGetApiResponse> {
  try {
    const params = {
      userId: request.userId,
      agencyCd: request.agencyCd,
    };
    const response = await axios.post<CategoryGetApiResponse>(`${url}`, params);
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
      case BAD_REQUEST.status:
      case MST_DATA_GET_FAILED.status:
        return data;
      case INTERNAL_SERVER_ERROR.status:
        throw new Error(data.result.resultCd);
      default:
        throw new Error('9999');
    }
  } catch (error) {
    const errCode = error.message;
    return {
      result: {
        jobDateTime: '',
        resultCd: '9999',
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG} エラーコード:${errCode}`,
          },
        ],
      },
    };
  }
}
